import React from 'react';
import { Popover, PopoverTitle, PopoverContent } from 'reactstrap';

export default class outPut extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <li className="list-group-item d-flex justify-content-between align-items-center">
                {this.props.name}:
                    <i className="fa fa-info" aria-hidden="true" id={"Popover1" + this.props.index} onClick={() => { this.setState({ popoverOpen: !this.state.popoverOpen }) }} ></i>
                <Popover placement="bottom" id={"Popover2" + this.props.index} isOpen={this.state.popoverOpen} target={"Popover1" + this.props.index} toggle={() => this.setState({ popoverOpen: !this.state.popoverOpen })}>
                    <PopoverTitle>Elementos:</PopoverTitle>
                    {this.props.items.map((e, index) => (
                        <PopoverContent>{e}</PopoverContent>
                    ))}
                </Popover>
                <span className="badge badge-default badge-pill">
                    <i className="fa fa-trash"
                        aria-hidden="true"
                        style={{ cursor: "pointer" }}
                        onClick={()=>this.props.callBack(this.props.name)}
                    />
                </span>
            </li>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/forms/outPut.js